import { useState } from "react";

export default function DropdownAbsolute({
  options,
  selectedOption,
  onChange,
}) {
  const [selected, setSelected] = useState(selectedOption || 1);

  const handleChange = (event) => {
    console.log(selected);
    // const selectedOption = options.find(option => option.value === event.target.value);
    setSelected(event.target.value);
    onChange(event);
  };

  return (
    <div className="relative flex ">
      <select
        value={selected}
        onChange={handleChange}
        className="inline-flex items-center cursor-pointer h-8 z-0 rounded-md border bg-white justify-center px-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-700 max-w-12"
      >
        {/* <option value={1}>{selectedOption}</option> */}
        {options.map((option, i) => (
          <option key={i} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
